import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import {
  Button,
  Card,
  Spinner,
  CardBody,
  Container,
  Row,
  Col,
} from "reactstrap";
import useGetAuthed from "../../helpers/hooks/useGetAuthed";

const AgroData = () => {
  //   STATES
  const [agroData, setAgroData] = useState(null);
  const { cnic } = useParams();

  // HOOKS

  const [agroDataResponse, agroError, agroLoading, getAgroCall] = useGetAuthed(
    `get_agro_data/${cnic}`,
    true,
    "loan"
  );
  useEffect(() => {
    if (agroDataResponse) {
      setAgroData(agroDataResponse);
    }
  }, [agroDataResponse]);

  // FUNCTIONS
  const bankAdmin = JSON.parse(localStorage.getItem("bankAdmin"));

  console.log(agroData, "AgroData1 data:");
  console.log(agroDataResponse, "agroDataResponse2 data:");
  return (
    <React.Fragment>
      <Container fluid>
        <div className="page-content">
          <Card>
            <CardBody>
              {!agroData ? (
                <div className="text-center">
                  <Spinner className="mr-2" color="primary" />
                </div>
              ) : (
                <div>
                  {!bankAdmin && (
                    <>
                      <Row className="d-flex justify-content-between  mb-2">
                        <Col className=" mt-2 ml-4">
                          <div className="align-items-end d-flex justify-content-between mb-3">
                            <h4>Agro Data</h4>

                            {/* ------------------BUTTONS------------------------- */}

                            {/* <div className="d-flex">
                              <Button
                                className="mr-1"
                                color="none"
                                style={{
                                  background: "rgb(221,248,238)",
                                  color: "rgb(58, 216, 147)",
                                  padding: "10px",
                                  width: " 9.5rem",
                                  fontSize: "0.8rem",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                Edit{"  "}
                                {"  "}
                                <i
                                  className=" fas fa-pencil-alt"
                                  style={{ fontSize: "0.9rem" }}
                                ></i>
                              </Button>{" "}
                              <Button
                                className="mr-1"
                                color="none"
                                style={{
                                  background: "rgb(228,235,240)",
                                  color: "rgb(165,178,193)",
                                  padding: "10px",
                                  width: " 9.5rem",
                                  fontSize: "0.8rem",
                                  whiteSpace: "nowrap",
                                }}
                                //   disabled={!feilds?.ismodified && !feilds?.user_response}
                                //   onClick={toggleRevision}
                              >
                                Upload Files{" "}
                                <i
                                  className="fas fa-file-alt"
                                  style={{ fontSize: "0.9em" }}
                                ></i>
                              </Button>{" "}
                            </div> */}
                            {/* -----------------------BUTTONS----------------- */}
                          </div>
                        </Col>
                      </Row>
                    </>
                  )}
                  <Card>
                    <CardBody id="data-table">
                      <div
                        className="table-responsive"
                        style={{ borderRadius: "13px" }}
                      >
                        <table className="table table-bordered">
                          <thead
                            style={{
                              backgroundColor: "rgb(246,251,253)",
                            }}
                          >
                            <tr>
                              {Object.keys(agroData).map((head) => {
                                if (head !== "_id") {
                                  return (
                                    <th
                                      key={head}
                                      className="table-header"
                                      style={{ width: "350px" }}
                                    >
                                      {head === "cnic"
                                        ? "CNIC"
                                        : head
                                            .split(" ")
                                            .map(
                                              (x) =>
                                                x.charAt(0).toUpperCase() +
                                                x.substring(1)
                                            )
                                            .join(" ")}
                                    </th>
                                  );
                                }
                              })}
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              {Object.keys(agroData).map((head) => {
                                if (head !== "_id") {
                                  return <td key={head}>{agroData[head]}</td>;
                                }
                              })}
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </CardBody>
                  </Card>
                </div>
              )}
            </CardBody>
          </Card>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default AgroData;
